import { Routes, Route } from 'react-router-dom';
import AMCList from '../pages/AMCList';
import AMCDetail from '../pages/AMCDetail';
import CreateAMC from '../pages/CreateAMC';
import MerchantConfigList from '../pages/MerchantConfigList';
import MerchantConfigDetail from '../pages/MerchantConfigDetail';
import PaymentConfigEdit from '../pages/PaymentConfigEdit';
import AMCDetailsTab from '../pages/AMCDetailTabs/AMCDetailsTab';
import AMCAssetsTab from '../pages/AMCDetailTabs/AMCAssetsTab';
import AssetDetail from '../pages/AssetDetail';
import AssetEdit from '../pages/AssetEdit';
import PaymentConfigWrapper from '../pages/PaymentConfigWrapper';
import PaymentRulesConfig from '@/pages/PaymentRulesConfig';
import SampleTransaction from '@/pages/SampleTransaction';
import AMCHistory from '@/pages/AMCHistory';
import AssetHistory from '@/pages/AssetHistory';
import MerchantConfigHistory from '@/pages/MerchantConfigHistory';
import DynamicRulesHistory from '@/pages/DynamicRulesHistory';
import PaymentConfigHistory from '@/pages/PaymentConfigHistory';

export default function AMCRouter() {
  return (
    <Routes>
      <Route index element={<AMCList />} />
      <Route path="create" element={<CreateAMC />} />

      <Route path=":id/history" element={<AMCHistory />} />
      <Route path=":id" element={<AMCDetail />}>
        <Route index element={<AMCDetailsTab />} />
        <Route path="assets" element={<AMCAssetsTab />} />
        <Route path="assets/:assetId" element={<AssetDetail />} />
        <Route path="assets/:assetId/edit" element={<AssetEdit />} />
        <Route path="assets/:assetId/payment-configs" element={<PaymentConfigWrapper />} />
        <Route path="assets/:assetId/try-dynamic-routing" element={<PaymentRulesConfig />} />
        <Route path="assets/:assetId/try-dynamic-routing/history" element={<DynamicRulesHistory />} />
        <Route path="assets/:assetId/sample-transaction" element={<SampleTransaction />} />
        <Route
          path="assets/:assetId/payment-configs/:configId/edit"
          element={<PaymentConfigEdit />}
        />
        <Route path="assets/:assetId/payment-configs/history" element={<PaymentConfigHistory />} />
        
        <Route path="assets/:assetId/history" element={<AssetHistory />} />
        <Route path="merchant-configs" element={<MerchantConfigList />} />
        <Route path="merchant-configs/:configId" element={<MerchantConfigDetail />} />
        <Route path="merchant-configs/:configId/history" element={<MerchantConfigHistory />} />
      </Route>
    </Routes>
  );
}
